import { useCallback, useEffect, useState } from "react";
import { Wifi, WifiOff, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { getQueue, syncQueue } from "../lib/offline";

export const SyncStatus = () => {
  const [online, setOnline] = useState(navigator.onLine);
  const [pending, setPending] = useState(getQueue().length);
  const [busy, setBusy] = useState(false);

  const sync = useCallback(async (manual = false) => {
    if (!getQueue().length) return;
    setBusy(true);
    const r = await syncQueue(api);
    setBusy(false);
    if (r.ok) toast.success(`${r.ok} transaksi offline berhasil disinkronkan`);
    if (r.failed) toast.error(`${r.failed} transaksi gagal sinkron, cek menu Transaksi`);
    else if (manual && !r.ok && !navigator.onLine) toast.error("Masih offline");
  }, []);

  useEffect(() => {
    const up = () => { setOnline(true); sync(); };
    const down = () => { setOnline(false); toast.warning("Koneksi terputus — mode offline aktif", { description: "Transaksi tetap bisa dilakukan dan akan disinkron otomatis." }); };
    const q = () => setPending(getQueue().length);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    window.addEventListener("pos-queue", q);
    const t = setInterval(() => navigator.onLine && sync(), 20000);
    sync();
    return () => {
      window.removeEventListener("online", up);
      window.removeEventListener("offline", down);
      window.removeEventListener("pos-queue", q);
      clearInterval(t);
    };
  }, [sync]);

  return (
    <button onClick={() => sync(true)} title={online ? "Online" : "Offline"} data-testid="sync-status"
      className={`flex items-center gap-1.5 text-xs font-medium px-2.5 py-1.5 rounded-full border transition-colors ${online ? "" : "border-destructive/50 bg-destructive/10 text-destructive"}`}>
      {online ? <Wifi className="h-3.5 w-3.5 text-success" /> : <WifiOff className="h-3.5 w-3.5" />}
      <span className="hidden sm:inline" data-testid="sync-status-label">{online ? "Online" : "Offline"}</span>
      {pending > 0 && (
        <span className="flex items-center gap-1 rounded-full bg-warning text-white px-1.5" data-testid="sync-pending-count">
          {busy && <RefreshCw className="h-3 w-3 animate-spin" />}{pending}
        </span>
      )}
    </button>
  );
};
